export enum ActiveField {
    KEYWORD = 'KEYWORD',
    LOCATION = 'LOCATION',
}
